import React from 'react';
import { motion } from 'framer-motion';

const SectionHero = () => (
  <section className="bg-secondary py-20">
    <div className="container mx-auto px-4">
      <motion.h1 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.7 }}
        className="text-3xl md:text-5xl font-bold text-white text-center mb-6"
      >
        Fast & Easy Personal Loans
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.3, duration: 0.7 }}
        className="text-lg md:text-xl text-white text-center mb-10 max-w-2xl mx-auto"
      >
        Get the financial support you need with our simple application process
      </motion.p>

      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5, duration: 0.7 }}
        className="flex justify-center"
      >
        <a 
          href="/apply-now" 
          className="bg-white text-secondary hover:bg-gray-100 font-bold py-3 px-8 rounded-lg text-xl uppercase shadow-lg transition-all duration-300"
        >
          Apply Now!
        </a>
      </motion.div>
    </div>
  </section>
);

export default SectionHero;
